function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { hideOthers } from './aria-hidden.js';
/**
 * A controller for handling modal state on the elements with `dialog` and `alertdialog` role.
 * See https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-modal
 *
 * Note, the actual `role` and `aria-modal` attributes are supposed to be handled by the
 * consumer web component. This is done in to ensure the controller only does one thing.
 */

export var AriaModalController = /*#__PURE__*/function () {
  /**
   * @param {HTMLElement} host
   */
  function AriaModalController(host, callback) {
    _classCallCheck(this, AriaModalController);

    /**
     * The controller host element.
     *
     * @type {HTMLElement}
     */
    this.host = host;
    /**
     * The callback used to detect which element
     * to use as a target. Defaults to the host.
     *
     * @type {Function}
     */

    this.callback = typeof callback === 'function' ? callback : function () {
      return host;
    };
  }
  /**
   * Make the controller host modal by hiding other elements from screen readers
   * using `aria-hidden` attribute (can be replaced with `inert` in the future).
   *
   * The method name is chosen to align with the one provided by native `<dialog>`:
   * https://developer.mozilla.org/en-US/docs/Web/API/HTMLDialogElement/showModal
   */


  _createClass(AriaModalController, [{
    key: "showModal",
    value: function showModal() {
      var targets = this.callback();
      this.__showOthers = hideOthers(targets);
    }
    /**
     * Remove `aria-hidden` from other elements unless there are any other
     * controller hosts on the page activated by using `showModal()` call.
     */

  }, {
    key: "close",
    value: function close() {
      if (this.__showOthers) {
        this.__showOthers();

        this.__showOthers = null;
      }
    }
  }]);

  return AriaModalController;
}();